import { render } from "./OpcaoComponent.vue?vue&type=template&id=0c9bf8f5&ts=true"
import script from "./OpcaoComponent.vue?vue&type=script&lang=ts"
export * from "./OpcaoComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__